import * as focusTrap from 'focus-trap';
import { KEYS } from '../constants';
import serialize from 'form-serialize';

class FindACommunityHeader {
  constructor({
    dom,
    openPrimaryNavChildMenu,
    closePrimaryNavChildMenu,
    displayPrimaryNavPanel,
    focusOutPrimaryNav
  }) {
    this.dom = {
      ...dom,
      $trigger: dom.$header._$('.find-a-community-header-trigger'),
      $panel: dom.$header._$('.find-a-community-header'),
      $form: dom.$header._$('.find-a-community-header__form')
    };

    this.openPrimaryNavChildMenu = openPrimaryNavChildMenu;
    this.closePrimaryNavChildMenu = closePrimaryNavChildMenu;
    this.displayPrimaryNavPanel = displayPrimaryNavPanel;
    this.focusOutPrimaryNav = focusOutPrimaryNav;

    this.id = 'find-a-community-header';
    this.expandedClass = 'find-a-community-header-trigger--expanded';

    this.locationName = this.dom.$form?.dataset?.locationName;
    this.countryName = this.dom.$form?.dataset?.countryName;
    this.careName = this.dom.$form?.dataset?.careName;

    this.addListeners();
    this.initiateFocusTrap();
  }

  addListeners() {
    this.dom.$trigger?._on('keydown', this.handleTriggerKeyDown.bind(this));
    this.dom.$trigger?._on('click', this.handleTriggerClick.bind(this));
    this.dom.$form?._on?.('submit', this.handleSubmit.bind(this));
    document._on('click', this.outterClickHandler.bind(this));
  }

  handleTriggerKeyDown(e) {
    switch (e.keyCode) {
      case KEYS.ESC:
        this.handleClose();
        break;
      case KEYS.DOWN:
      case KEYS.ENTER:
        e.preventDefault();
        this.handleTriggerClick(e);
        this.panelFocusTrap.activate();
        break;
    }
  }

  outterClickHandler(e) {
    const headerPanel = document.querySelector('.header__panel');
    if (headerPanel && !headerPanel.contains(e.target)) {
      this.handleClose();
    }
  }

  handleTriggerClick() {
    if (this.dom.$trigger.classList.contains(this.expandedClass)) {
      this.handleClose();
    } else {
      this.openPrimaryNavChildMenu();
      this.dom.$trigger.classList.add(this.expandedClass);
      this.displayPrimaryNavPanel(this.id);
      this.focusOutPrimaryNav();
    }
  }

  handleClose() {
    this.focusOut();
    this.closePrimaryNavChildMenu();
  }

  handleSubmit(e) {
    e.preventDefault();
    const data = serialize(this.dom.$form, { hash: true });
    const isDataEntered = data[this.locationName] || data[this.careName];
    let url = isDataEntered
      ? this.dom.$form.dataset.mapViewUrl
      : this.dom.$form.dataset.countryViewUrl;
    url = `${url}?${serialize(this.dom.$form)}`;
    this.dom.$form.action = url;
    this.dom.$form.submit();
  }

  initiateFocusTrap() {
    this.panelFocusTrap = focusTrap.createFocusTrap(this.dom.$childNavWrapper, {
      allowOutsideClick: false,
      onDeactivate: this.handleClose.bind(this),
      initialFocus: () => {
        return this.dom.$panel.getElementsByTagName('INPUT')[0];
      }
    });
  }

  focusOut() {
    this.dom.$trigger?.classList.remove(this.expandedClass);
  }
}

export default FindACommunityHeader;
